v-row
  v-col(cols="12")
    colored-radio-group(
      v-model="incident.confirmed"
      :label="label"
      inline
      :rules="[incident.validCheck('confirmed')]"
    )
      v-radio(
        :label="$t('common.yes')"
        :value="true"
      )
      v-radio(
        :label="$t('common.no')"
        :value="false"
      )

    if incident.confirmed
      for item, index in incident.history
        v-row(:key="index")
          v-col(cols="12" md="5")
            v-text-field(
              v-model="item.type"
              :label="typeLabel"
              :rules="[item.validCheck('type')]"
            ) 
          v-col(cols="12" md="5")
            v-text-field(
              v-model="item.when"
              :label="whenLabel"
              :rules="[incident.validCheck('when')]"
            )
        
